import { render, staticRenderFns } from "./RecordLabelShow.vue?vue&type=template&id=44d5d1fe"
import script from "./RecordLabelShow.vue?vue&type=script&lang=js"
export * from "./RecordLabelShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports